import { connect } from "react-redux";
import { getListTraGop } from "actions/TraGop";
import { getLanDongLaiChoVay, getLaiDenNgayChoVay } from "actions/QuanLyChoVay";
import { getComboUser } from "actions/User";
import { getConfig } from "actions/CauHinh";
import { showXoaHopDong } from "actions/XoaHopDong";
import { showInMaVachTaiSan } from "actions/InMaVachTaiSan";
import { showModalGuiEmail } from "actions/GuiEmail";
import { showModalGuiTinNhan } from "actions/GuiTinNhan";
import { getPhanQuyenTraGop } from "actions/PhanQuyen";
import { showModalLoaiTaiSan } from "actions/LoaiTaiSan";
import { showInPhieuThuChi } from "actions/InThuChi";
import { showFormTraGop } from "actions/ThemMoiTraGop";
import { showFormDaoHo } from "actions/TraGop/DaoHo";
import { getConfigSysTMTG } from "actions/ThemMoiTraGop";
import { showModalGhiChuChoVay } from "actions/GhiChuChoVay";
import TraGopNoXau from "components/DanhSachNoXau/TraGop";

const mapStateToProps = (state) => ({
  tragop: state.tragop,
  user: state.user,
  phanquyen: state.phanquyen,
  inthuchi: state.inthuchi,
  themmoitragop: state.themmoitragop,
  daoho: state.daoho,
  ghichuchovay: state.ghichuchovay,
  cauhinh: state.cauhinh,
});

const mapDispatchToProps = (dispatch) => ({
  // getListTraGop: (dataSearch) => dispatch(getListTraGop(dataSearch)),
  getListTraGop: (dataSearch) => {
    const newDataSearch = {
      ...dataSearch,
      debt: 50, // Gán lại luôn
    };
    dispatch(getListTraGop(newDataSearch));
  },
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
  getLaiDenNgayChoVay: (data) => dispatch(getLaiDenNgayChoVay(data)),
  getComboUser: () => dispatch(getComboUser()),
  getConfig: () => dispatch(getConfig()),
  showXoaHopDong: () => dispatch(showXoaHopDong()),
  showInMaVachTaiSan: () => dispatch(showInMaVachTaiSan()),
  showModalGuiEmail: () => dispatch(showModalGuiEmail()),
  showModalGuiTinNhan: () => dispatch(showModalGuiTinNhan()),
  getPhanQuyenTraGop: (data) => dispatch(getPhanQuyenTraGop(data)),
  showModalLoaiTaiSan: (data) => dispatch(showModalLoaiTaiSan(data)),
  showInPhieuThuChi: (thuChiId) => dispatch(showInPhieuThuChi(thuChiId)),
  showFormTraGop: (data) => dispatch(showFormTraGop(data)),
  showFormDaoHo: (data) => dispatch(showFormDaoHo(data)),
  getConfigSysTMTG: (data) => dispatch(getConfigSysTMTG(data)),
  showModalGhiChuChoVay: () => dispatch(showModalGhiChuChoVay()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TraGopNoXau);
